import { render, staticRenderFns } from "./TypeAnswer.vue?vue&type=template&id=08ba4ca8"
import script from "./TypeAnswer.vue?vue&type=script&lang=js"
export * from "./TypeAnswer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports